const Lato_700Bold = {fontFamily: 'Hind-Siliguri'};
const Lato_400Regular = {fontFamily: 'Hind-Siliguri'};

const LeagueSpartan_700Bold = {fontFamily: 'Hind-Siliguri'};
const LeagueSpartan_300Light = {fontFamily: 'Hind-Siliguri'};
const LeagueSpartan_500Medium = {fontFamily: 'Hind-Siliguri'};
const LeagueSpartan_400Regular = {fontFamily: 'Hind-Siliguri'};
const LeagueSpartan_600SemiBold = {fontFamily: 'Hind-Siliguri'};

export const fonts = {
  Lato_700Bold,
  Lato_400Regular,
  LeagueSpartan_700Bold,
  LeagueSpartan_300Light,
  LeagueSpartan_500Medium,
  LeagueSpartan_400Regular,
  LeagueSpartan_600SemiBold,
};
